// AssociateMesureModal.jsx 📎 Liaison mesure ↔️ risque
import React, { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import axios from "axios";
import "./AssociateMesureModal.css";

export default function AssociateMesureModal({ show, onClose, risk, onAssociated, showToast }) {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (show) {
      fetchMesures();
      setSelected([]); // reset à chaque ouverture
    }
  }, [show]);

  const fetchMesures = async () => {
    try {
      const res = await axios.get("/api/options_mesures.php");
      setOptions(res.data?.mesures || []);
    } catch (e) {
      showToast("Erreur chargement mesures", "danger");
    }
  };

  const handleSelectChange = (e) => {
    const values = Array.from(e.target.selectedOptions).map((o) => o.value);
    setSelected(values);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!risk?.id || selected.length === 0) return;

    try {
      await axios.post("/api/associate_mesures.php", {
        risk_id: risk.id,
        mesure_ids: selected,
      });
      showToast("Mesure(s) associée(s) !");
      onAssociated?.();
      onClose();
    } catch {
      showToast("Erreur association mesure", "danger");
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="associate-mesure-modal"
    >
      <Form onSubmit={handleSubmit}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Associer des Mesures
            </h5>
            <button className="btn-close btn-close-white" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            <p className="text-light mb-2">
              <strong>Risque :</strong> {risk?.nom}
            </p>

            <Form.Label className="text-light">Sélectionner les mesures à associer</Form.Label>
            <Form.Select
              multiple
              className="associate-mesure-select"
              value={selected}
              onChange={handleSelectChange}
            >
              {options.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.name} ({m.type}) - 🔻 {m.reduction}
                </option>
              ))}
            </Form.Select>
            <small className="text-secondary">Maintenir CTRL (ou CMD) pour multi-sélection</small>
          </div>

          <div className="modal-footer">
            <Button variant="secondary" onClick={onClose}>
              Annuler
            </Button>
            <Button variant="success" type="submit" disabled={selected.length === 0}>
              Associer
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  );
}
